import { Navigate } from "react-router-dom";
import { isAdminRole } from "@/lib/api";

function readCachedUser() {
  try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
}

export default function MobileAdminRoute({ children }) {
  const user = readCachedUser();
  if (!isAdminRole(user)) return <Navigate to="/m" replace />;
  return children;
}
